import { authenticatedAxios } from "lib/actions/fetcher";
import { endpointsSpeckle } from "./endpointsSpeckle";

export async function getPkceChallenge() {
  try {
    const res = await authenticatedAxios.get(
      endpointsSpeckle.pkceGenerateChallenge,
    );

    const codeChallenge = res.data.codeChallenge;
    const codeVerifier = res.data.codeVerifier;

    localStorage.setItem("speckleCodeVerifier", codeVerifier);

    return codeChallenge;
  } catch (e) {
    console.error(e);
    return null;
  }
}
